import axios from "axios";
import { authHeader, hasAuth } from "./auth.header";
import { JsonLine } from "../types";

/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
	if (process.env.REACT_APP__API_URL) return process.env.REACT_APP__API_URL;

	const origin: string = window.location.origin;
	return origin.replace('3000', '5047');
}
/* -------------------------------------------------------------------------------- *\
|                               getlast
\* -------------------------------------------------------------------------------- */
export const getlast = async () : Promise<any[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getlast`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as any[];
			return datas;
		});
}
